import React, { createContext, useContext, useState } from 'react';

const lightPalette = {
  accents_1: '#f0f0f0',
  accents_2: '#e0e0e0',
  accents_3: '#d0d0d0',
  accents_4: '#c0c0c0',
  accents_5: '#666666'
};

const darkPalette = {
  accents_1: '#111111',
  accents_5: '#eeeeee'
};

const ThemeContext = createContext();

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
  localStorage.theme = 'light';
  const [theme, setTheme] = useState('light'); // Default theme

  // Toggle between 'light' and 'dark'
  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'));
  };

  const palette = theme === 'light' ? lightPalette : darkPalette;

  return <ThemeContext.Provider value={{ theme, palette, toggleTheme }}>{children}</ThemeContext.Provider>;
};
